import React, { Component } from "react";

/// String
import { Strings } from "../../resources/i18n/i18n";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { WHATSAPP_TABS } from "./Constants";
import { ROUTES } from "../../constants/routeConstants";
import { Route, Switch, withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Row } from "react-bootstrap";

import WhatsappInterestContainer from "./WhatsappInterest/WhatsappInterestContainer";
import WhatsappMinimartListContainer from "./WhatsappMinimartList/WhatsappMinimartListContainer";

class WhatsappContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Tabs: WHATSAPP_TABS,
            activeTab: WHATSAPP_TABS[0],
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const path = nextProps.history.location.pathname;
        let derivedState = {};

        if (
            path === ROUTES.MTP_WHATSAPP ||
            path === ROUTES.WHATSAPP_INTEREST
        ) {
            derivedState = {
                ...derivedState,
                activeTab: prevState.Tabs[0], 
            };
        } else if (path === ROUTES.WHATSAPP_MINIMART_LIST) {
            derivedState = {
                ...derivedState,
                activeTab:
                    prevState.Tabs.length > 1 ? prevState.Tabs[1] : prevState.Tabs[0],
            };
        }

        return derivedState;
    }

    handleTabs = (index) => {
        const selectedTab = this.state.Tabs[index];

        this.setState({ activeTab: selectedTab }, () => {
            this.props.history.push(ROUTES[selectedTab.value]);
        });
    };

    renderInterestPanel = () => (
        <TabPanel className="WorkHistoryContainer">
            <Switch>
                <Route
                    exact
                    path={[ROUTES.MTP_WHATSAPP, ROUTES.WHATSAPP_INTEREST]}
                    render={() => <WhatsappInterestContainer />}
                />
            </Switch>
        </TabPanel>
    );

    renderMinimartPanel = () => (
        <TabPanel className="WorkHistoryContainer">
            <Switch>
                <Route
                    exact
                    path={ROUTES.WHATSAPP_MINIMART_LIST}
                    render={() => <WhatsappMinimartListContainer />}
                />
            </Switch>
        </TabPanel>
    );

    render() {
        const selectedIndex = Math.max(
            0,
            this.state.Tabs.findIndex(
                (tab) => tab.value === this.state.activeTab.value
            )
        );

        return (
            <div className="generalReports">
                <Row className="heading">{Strings("WhatsApp")}</Row>

                <Tabs selectedIndex={selectedIndex} onSelect={this.handleTabs}>
                    <TabList>
                        {this.state.Tabs.map((item) => (
                            <Tab
                                key={item.key}
                                className={
                                    item.value === this.state.activeTab.value
                                        ? "react-tabs__tab react-tabs__tab--selected mt-1"
                                        : "react-tabs__tab mt-1"
                                }
                            >
                                {item.label}
                            </Tab>
                        ))}
                    </TabList>
                    {this.renderInterestPanel()}
                    {this.renderMinimartPanel()}
                </Tabs>
            </div>
        );
    }
}

export default withRouter(WhatsappContainer);
